import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import NoBrokeragePage from "../components/NoBrokeragePage";

const NoBrokeragePolicy = () => {
    return(
        <div>
            <NavBar/>
            <NoBrokeragePage/>
            <Footer/>
        </div>
    )
}

export default NoBrokeragePolicy;